// When billing-portal-ui is rendered inside the Theme Editor (theme-previewer),
// there is no __hsmem cookie for member authentication. Instead, the theme
// editor passes a previewJwt token via the URL hash (#previewJwt=<token>)
// and an isPortalPreview query param.

export const getPreviewState = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const isPreview = Boolean(searchParams.get('isPortalPreview'));
  if (isPreview) {
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const previewJwt = hashParams.get('previewJwt');
    return {
      isPreview: true,
      previewJwt: previewJwt !== null && previewJwt !== void 0 ? previewJwt : ''
    };
  }
  return {
    isPreview: false,
    previewJwt: null
  };
};